/* eslint-disable */
import React, { useContext, useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import api, { authHeader } from '../../../../../services/API/apiConfig';

import { Grid2 } from '@mui/material';
import { TourContext } from '../../../../../context/tour';
import {
  CheckedIconStyled,
  CustomScrollbarStyled,
  IconStyled,
  LinearProgressStyled,
  RootStyled,
} from './styles';

const tutorials = [
  { name: 'Boas vindas à Sioon', step: 1, route: '/admin', check: 'onBoarding' },
  { name: 'Home', step: 3, route: '/admin', check: 'home' },
  { name: 'Clientes', step: 5, route: '/new-client', check: 'clients' },
  { name: 'Obras 0/7' },
  { name: 'Fornecedores', step: 21, route: '/suppliers', check: 'suppliers' },
  { name: 'Categorias', step: 23, route: '/categories', check: 'categories' },
  { name: 'Lançamentos', step: 25, route: '/new-release', check: 'newRelease' },
];

const constructionsTour = [
  {
    name: 'Cadastro',
    step: 7,
    route: '/constructions',
    check: 'constructionsForm',
  },
  {
    name: 'Lançamentos',
    step: 9,
    route: '/constructions/tour/payables',
    check: 'payables',
  },
  {
    name: 'Orçamentos',
    step: 11,
    route: '/constructions/tour/budgets',
    check: 'budgets',
  },
  {
    name: 'Cronograma',
    step: 13,
    route: '/constructions/tour/schedules',
    check: 'schedules',
  },
  {
    name: 'Fotos',
    step: 15,
    route: '/constructions/tour/photos',
    check: 'photos',
  },
  {
    name: 'Documentos',
    step: 17,
    route: '/constructions/tour/documents',
    check: 'documents',
  },
  {
    name: 'Dashboard',
    step: 19,
    route: '/constructions/tour/dashboard',
    check: 'dashboard',
  },
];

function ProgressBox() {
  const {
    setTutorialStep,
    setDialogOpen,
    setProgressOpen,
    tourPercentage,
    tourCompletion,
  } = useContext(TourContext);

  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);
  const [constructions, setConstructions] = useState(null);

  const constructionsProgress = useMemo(() => {
    const progress = [
      tourCompletion.constructionsForm.complete,
      tourCompletion.payables.complete,
      tourCompletion.budgets.complete,
      tourCompletion.schedules.complete,
      tourCompletion.photos.complete,
      tourCompletion.documents.complete,
      tourCompletion.dashboard.complete,
    ];
    return progress.filter((isComplete) => isComplete).length;
  }, [tourCompletion]);

  useEffect(() => {
    api.get('/constructions', { headers: authHeader() }).then((res) => {
      setConstructions(res.data.data);
    });
  }, []);

  const handleTourSelection = (step, route, isConstruction = true) => {
    setTutorialStep(step);
    setDialogOpen(true);
    setProgressOpen(false);
    navigate(route);
  };

  return (
    <RootStyled container spacing={2}>
      <Grid2 item style={{ width: '100%' }}>
        <Typography
          component="h4"
          variant="h2"
          style={{ color: '#1d6fbb', fontWeight: 600 }}
        >
          Bem vindo(a) à bordo!
        </Typography>
        <Typography
          component="p"
          style={{
            color: true ? '#000' : '#22b07d',
            fontSize: '1rem',
            fontWeight: true ? 400 : 600,
            marginTop: '8px',
          }}
        >
          {true
            ? 'Aqui está o checklist do seu tour'
            : 'Parabéns, você concluiu o Tour.'}
        </Typography>
        <Grid2 item container direction="row" alignItems="center" spacing={2}>
          <Grid2 item>
            <Typography
              component="span"
              style={{ fontWeight: 700, color: '#1d6fbb', fontSize: '1rem' }}
            >
              {`${tourPercentage}%`}
            </Typography>
          </Grid2>
          <Grid2 item style={{ width: '80%', margin: '16px 0' }}>
            <LinearProgressStyled
              variant="determinate"
              value={tourPercentage}
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <CustomScrollbarStyled item container direction="row">
        {tutorials.map(({ name, step, route, check }) => {
          if (name.includes('Obras')) {
            const constructionsChecks = constructionsTour.map(
              (tour) => tourCompletion[tour.check].complete
            );

            return (
              <>
                <Grid2
                  key={name}
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ width: '90%' }}
                >
                  <Grid2 item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          style={{ cursor: 'not-allowed' }}
                          checked={constructionsChecks.every((c) => c)}
                          checkedIcon={<CheckedIconStyled />}
                          icon={<IconStyled />}
                        />
                      }
                      label={
                        <Typography
                          onClick={() => setExpanded(!expanded)}
                          component="span"
                          style={{ fontSize: '1rem' }}
                        >
                          {`Obras ${constructionsProgress}/7`}
                        </Typography>
                      }
                    />
                  </Grid2>
                  <Grid2 item>
                    <IconButton
                      aria-label={expanded ? 'expand-less' : 'expand-more'}
                      onClick={() => setExpanded(!expanded)}
                      size="large"
                    >
                      {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                  </Grid2>
                </Grid2>
                {expanded &&
                  constructionsTour.map((section) => (
                    <Grid2
                      key={section.name}
                      item
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      style={{
                        marginLeft: '10%',
                        width: '80%',
                      }}
                    >
                      <Grid2 item>
                        <FormControlLabel
                          control={
                            <Checkbox
                              style={{ cursor: 'not-allowed' }}
                              checked={tourCompletion[section.check].complete}
                              checkedIcon={<CheckedIconStyled />}
                              icon={<IconStyled />}
                            />
                          }
                          label={
                            <Typography
                              component="span"
                              style={{ fontSize: '1rem' }}
                              onClick={() =>
                                handleTourSelection(section.step, section.route)
                              }
                            >
                              {section.name}
                            </Typography>
                          }
                        />
                      </Grid2>
                    </Grid2>
                  ))}
              </>
            );
          }

          return (
            <Grid2
              key={name}
              item
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              style={{ width: '90%' }}
            >
              <Grid2 item>
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ cursor: 'not-allowed' }}
                      checked={tourCompletion[check].complete}
                      checkedIcon={<CheckedIconStyled />}
                      icon={<IconStyled />}
                    />
                  }
                  label={
                    <Typography
                      component="span"
                      style={{ fontSize: '1rem' }}
                      onClick={() => handleTourSelection(step, route, false)}
                    >
                      {name}
                    </Typography>
                  }
                />
              </Grid2>
            </Grid2>
          );
        })}
      </CustomScrollbarStyled>
    </RootStyled>
  );
}

export default ProgressBox;
